import StandFiltersForm from "./stand-filters-form";

export default StandFiltersForm;